export const lightBlueMui = {
  /**
   * Preview: ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png)
   */
  _50: "#e1f5fe",
  /**
   * Preview: ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png)
   */
  _100: "#b3e5fc",
  /**
   * Preview: ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png)
   */
  _200: "#81d4fa",
  /**
   * Preview: ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png)
   */
  _300: "#4fc3f7",
  /**
   * Preview: ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png)
   */
  _400: "#29b6f6",
  /**
   * Preview: ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png)
   */
  _500: "#03a9f4",
  /**
   * Preview: ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png)
   */
  _600: "#039be5",
  /**
   * Preview: ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png)
   */
  _700: "#0288d1",
  /**
   * Preview: ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png)
   */
  _800: "#0277bd",
  /**
   * Preview: ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png)
   */
  _900: "#01579b",
  /**
   * Preview: ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png)
   */
  A100: "#80d8ff",
  /**
   * Preview: ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png)
   */
  A200: "#40c4ff",
  /**
   * Preview: ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png)
   */
  A400: "#00b0ff",
  /**
   * Preview: ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
   */
  A700: "#0091ea",
};
